import { render, staticRenderFns } from "./ProductSpecsElementEdit.vue?vue&type=template&id=0c51510e"
import script from "./ProductSpecsElementEdit.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports